import { haveFilterQuery, paginator, haveSort } from '../../common/auxFun'

const endpointsPurchasesFuel = {
  CREATE: '/v1/purchases/suppliers',
  LOAD: (filter, sort, limit, skip) =>
    `/v1/purchases/suppliers${haveFilterQuery(filter)}${paginator(limit, skip)}${haveSort(sort)}`,
  BY_ID: (id) => `/v1/purchases/suppliers/${id}`,
}

export default endpointsPurchasesFuel
